/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

import useWindowSize from '../../hooks/useWindowSize';

import PatchedText from '../partials/PatchedText';
import Arrow from '../buttons/Arrow';

// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/blocks/gallery.scss';

const propTypes = {
    id: PropTypes.number.isRequired,
    gallery: PropTypes.array, // eslint-disable-line
    isLast: PropTypes.bool,
    delay: PropTypes.number,
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    gallery: [],
    isLast: false,
    delay: 4000,
    color: null,
    className: null,
};

const GalleryBlock = ({ id, gallery, isLast, delay, color, className }) => {
    const { width } = useWindowSize();
    const screenSmall = width < 790;

    const [currentIndex, setCurrentIndex] = useState(0);
    const [automaticSlide, setAutomaticSlide] = useState(true);
    const [timeoutId, setTimeoutId] = useState(true);

    const nextSlide = () => {
        if (
            (!screenSmall && currentIndex === gallery.length - 2) ||
            currentIndex === gallery.length - 1
        ) {
            return setCurrentIndex(0);
        }
        return setCurrentIndex(currentIndex + 1);
    };

    const onRightArrowClick = () => {
        setAutomaticSlide(false);
        return nextSlide();
    };

    const onLeftArrowClick = () => {
        setAutomaticSlide(false);
        if (currentIndex === 0) {
            if (!screenSmall) {
                return setCurrentIndex(gallery.length - 2);
            }
            return setCurrentIndex(gallery.length - 1);
        }
        return setCurrentIndex(currentIndex - 1);
    };

    useEffect(() => {
        let tid;
        if (automaticSlide) {
            tid = setTimeout(() => nextSlide(), delay);
            setTimeoutId(tid);
        }
        return () => {
            clearTimeout(tid);
        };
    }, [currentIndex, delay]);

    useEffect(() => {
        if (automaticSlide === false) {
            clearTimeout(timeoutId);
        }
    }, [automaticSlide, timeoutId]);

    return (
        <div
            className={classNames({
                [styles.container]: true,
                [styles.isLast]: isLast,
                [className]: className !== null,
            })}
        >
            <div className={styles.inner}>
                <Arrow
                    onClick={() => onLeftArrowClick()}
                    isLeft
                    color={color}
                    className={classNames([styles.arrow, styles.arrowLeft])}
                />
                <div className={styles.slides}>
                    {gallery !== null
                        ? gallery.map((slide, index) => {
                              return (
                                  <div
                                      className={styles.slide}
                                      key={`slide-${id}-${index + 1}`}
                                      style={{
                                          transform: `translate3d(${(index - currentIndex) *
                                              100}%, 0px, 0px)`,
                                      }}
                                  >
                                      <div
                                          className={styles.image}
                                          style={{
                                              backgroundImage: `url(${slide.url})`,
                                          }}
                                      >
                                          {slide.credit ? (
                                              <PatchedText
                                                  label={`©${slide.credit}`}
                                                  className={styles.credits}
                                                  backgroundClassName={styles.creditsBackground}
                                              />
                                          ) : null}
                                      </div>
                                  </div>
                              );
                          })
                        : null}
                </div>
                <Arrow
                    onClick={() => onRightArrowClick()}
                    color={color}
                    className={classNames([styles.arrow, styles.arrowRight])}
                />
            </div>
        </div>
    );
};

GalleryBlock.propTypes = propTypes;
GalleryBlock.defaultProps = defaultProps;

const WithStateContainer = connect(({ site: { color } }) => ({
    color: color || null,
    // color: mergeProps.color ? mergeProps.color : color,
    // theme: mergeProps.theme ? mergeProps.theme : theme,
}))(GalleryBlock);

export default WithStateContainer;
